import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function ShopTitle() {
  return <section data-section-id="223412" id="shop-title" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 flex flex-col items-center text-center">
        <Breadcrumb className="mb-8">
          <BreadcrumbList className="uppercase tracking-widest text-[10px] font-sans font-semibold text-muted-foreground">
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="#">Home</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-primary">The Pantry</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <h1 className="font-default text-5xl md:text-6xl lg:text-7xl font-medium tracking-tight text-foreground">
          The Pantry
        </h1>

        <p className="mt-6 text-muted-foreground text-lg md:text-xl max-w-2xl leading-relaxed font-sans">
          Explore our daily selection of artisan breads, golden pastries, and seasonal treats. Handcrafted every morning with heritage grains and a touch of nostalgia.
        </p>
      </div>
    </section>;
}